import {
  SET_FILTERS,
  SEARCH,
  SET_TABLE_SETTINGS,
  APPLY_PRESET,
} from '@gogame/screens';

import { tableSettingsSchema, presetSchema } from './schemas';

const REORDER_COLUMNS = 'REORDER_COLUMNS';
const COLLAPSE_COLUMNS = 'COLLAPSE_COLUMNS';

export { REORDER_COLUMNS, COLLAPSE_COLUMNS, SET_TABLE_SETTINGS };

export default function influencersCampaignsReducer(
  state = { ready: false },
  action
) {
  switch (action.type) {
    case REORDER_COLUMNS:
      return { ...state, columns: { ...state.columns, order: action.payload } };
    case COLLAPSE_COLUMNS:
      return {
        ...state,
        columns: { ...state.columns, collapsed: action.payload },
      };

    case SET_FILTERS:
      return {
        ...state,
        // reset table settings on changing filters
        tableSettings: {
          ...tableSettingsSchema.default(),
          limit: state.tableSettings.limit,
        },
        filters: action.payload,
        ready: true,
      };

    case SEARCH:
      return {
        ...state,
        // reset table settings on changing search
        tableSettings: {
          ...tableSettingsSchema.default(),
          limit: state.tableSettings.limit,
        },
        searchQuery: action.payload,
        ready: true,
      };

    case SET_TABLE_SETTINGS:
      return {
        ...state,
        tableSettings: { ...state.tableSettings, ...action.payload },
        ready: true,
      };

    case APPLY_PRESET:
      if (action.payload) {
        const { id, data } = action.payload;
        const { applyPresetData } = action.meta;

        // if applyPresetData is 'false', it is new preset and it's data equal to current state
        return {
          ...(applyPresetData
            ? presetSchema.cast(data, { parseConst: true })
            : state),
          presetId: id,
          ready: true,
        };
      }
      // Active preset was removed
      return {
        ...state,
        // clean activePresetId
        presetId: undefined,
      };

    default:
      return state;
  }
}
